import { Delegation } from "../types";
import { moduleLabel } from "../utils";

export function DelegationTable({
  delegations,
  onDelete,
}: {
  delegations: Delegation[];
  onDelete: (id: number) => void;
}) {
  if (!delegations.length) {
    return (
      <div className="rounded-2xl border bg-white p-6 text-center text-sm text-slate-500">
        No delegations configured.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto rounded-2xl border bg-white">
      <table className="w-full text-sm">
        <thead className="bg-slate-100 text-left text-slate-700">
          <tr>
            <th className="p-3">Delegator</th>
            <th className="p-3">Delegate</th>
            <th className="p-3">Module</th>
            <th className="p-3">Period</th>
            <th className="p-3">Reason</th>
            <th className="p-3">Auto Reassign</th>
            <th className="p-3">Active</th>
            <th className="p-3 text-right">Actions</th>
          </tr>
        </thead>

        <tbody>
          {delegations.map((d) => (
            <tr key={d.id} className="border-t">
              <td className="p-3">{d.delegatorUsername}</td>
              <td className="p-3">{d.delegateUsername}</td>
              <td className="p-3">{moduleLabel(d.moduleCode)}</td>
              <td className="p-3">
                {d.startDate} to {d.endDate}
              </td>
              <td className="p-3">{d.reason || "-"}</td>
              <td className="p-3">{d.autoReassignPending ? "Yes" : "No"}</td>
              <td className="p-3">{d.active ? "Yes" : "No"}</td>
              <td className="p-3 text-right">
                <button
                  onClick={() => onDelete(d.id)}
                  className="text-red-600 hover:underline"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}